import RoleCodesEnum from '../enums/roles/role-codes.enum';
import { authState } from '../http/auth.state';

const { ADMIN, SUPER_ADMIN } = RoleCodesEnum;

export const roleIsAdmin = (): boolean =>
  !!authState.role && [ADMIN, SUPER_ADMIN].includes(authState.role);
